import { take, unique } from 'lib/array/arrayUtils'
import { extractCookie } from 'lib/web/cookieUtils'

export const recentlyViewedExperiencesCookieKey = 'recentlyViewedExperiences'

export function addRecentlyViewedExperience(experienceId: string) {
  const cookieValue = extractCookie(document.cookie, recentlyViewedExperiencesCookieKey) ?? ''
  const existingIds = cookieValue.split(',').filter(Boolean)

  const nextIds = take(unique([experienceId, ...existingIds]), 5)
  document.cookie = `${recentlyViewedExperiencesCookieKey}=${nextIds}; expires=Fri, 29 Dec 2028 23:59:59 GMT; path=/; domain=${document.domain}`
}
